import React from "react";
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Stack,
  Chip,
  Box,
  Tooltip,
} from "@mui/material";

export const SubjectPicker = ({
  subjects = [],
  selectedSubject,
  setSelectedSubject,
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="subject-label">Subject</InputLabel>
      <Select
        labelId="subject-label"
        label="Subject"
        value={selectedSubject || ""}
        onChange={(e) => setSelectedSubject(e.target.value)}
      >
        {subjects.map((sub) => (
          <MenuItem key={sub.id} value={sub}>
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              width="100%"
            >
              <Box>{sub.name}</Box>

              {sub?.feedbackFrameworks?.length > 0 && (
                <Tooltip title="School Feedback Framework Available" arrow>
                  <Chip
                    label={`Frameworks: ${sub.feedbackFrameworks
                      .map((fw) => fw.educationLevel.level)
                      .join(", ")}`}
                    size="small"
                  />
                </Tooltip>
              )}
            </Stack>
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const EducationLevelPicker = ({
  educationLevels = [],
  selectedEducationLevel,
  setSelectedEducationLevel,
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="education-level-label">Education Level</InputLabel>
      <Select
        labelId="education-level-label"
        label="Education Level"
        value={selectedEducationLevel || ""}
        onChange={(e) => setSelectedEducationLevel(e.target.value)}
      >
        {educationLevels.map((level) => (
          <MenuItem key={level.id} value={level}>
            {level.level}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const YearGroupPicker = ({
  yearGroups = [],
  selectedYearGroup,
  setSelectedYearGroup,
}) => {
  return (
    <FormControl fullWidth>
      <InputLabel id="year-group-label">Year Group</InputLabel>
      <Select
        labelId="year-group-label"
        label="Year Group"
        value={selectedYearGroup || ""}
        onChange={(e) => setSelectedYearGroup(e.target.value)}
      >
        {yearGroups.map((yg) => (
          <MenuItem key={yg.id} value={yg}>
            {yg.yearGroup}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};

export const SubjectYearGroupPicker = (props) => {
  const {
    subjects,
    educationLevels,
    yearGroups,
    selectedSubject,
    setSelectedSubject,
    selectedEducationLevel,
    setSelectedEducationLevel,
    selectedYearGroup,
    setSelectedYearGroup,
    stackProps = {},
  } = props;

  return (
    <Stack
      direction="column"
      spacing={2}
      width="40%"
      sx={{ mt: 2, mb: 2 }}
      {...stackProps}
    >
      <SubjectPicker
        subjects={subjects}
        selectedSubject={selectedSubject}
        setSelectedSubject={setSelectedSubject}
      />

      <EducationLevelPicker
        educationLevels={educationLevels}
        selectedEducationLevel={selectedEducationLevel}
        setSelectedEducationLevel={setSelectedEducationLevel}
      />

      <YearGroupPicker
        yearGroups={yearGroups}
        selectedYearGroup={selectedYearGroup}
        setSelectedYearGroup={setSelectedYearGroup}
      />
    </Stack>
  );
};
